<template>
  <router-view />
</template>

<script>
export default {
  name: 'OutLayout',
};
</script>



// WEBPACK FOOTER //
// src/layouts/OutLayout.vue